import React, { Component } from "react";
import { withStyles } from "@material-ui/core";
import crStyles from "../../../customerReservation/crStyles";
import sharedStyles from "../OrderDetailsNewVersion.module.scss";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Radio from "@material-ui/core/Radio";
import styles from "./PaymentMethod.module.scss";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import CheckBox from "../../../../shared/checkBox/CheckBox";
import checkboxStyles from "../../../../shared/checkBox/CheckBox.module.scss";
import {
  CASH,
  FINANCE,
  FINANCE_OPTIONS,
  LEASE,
  OFFLINE_FINANCE,
  OFFLINE_LEASE,
  OFFLINEFINANCE,
  OFFLINELEASE,
  SUBMITTED,
  PRIVATE_LEASE,
  OFFLINE_PRIVATE_LEASE,
  OFFLINEPRIVATELEASE,
  AL,
  CANCELLED,
  DENIED,
  ERROR,
  OPT_OFFLINE,
  TIMED_OUT,
  FINANCE_REFERRED,
  FINANCE_EID_CHECKED_FAIL,
  PROPOSAL_EXPIRED,
} from "../../../../common/Constants";
import CapitalizeText from "../../../../utils/CapitalizeText";
import { withTranslation } from "react-i18next";
import PaymentMethodDialog from "../../PaymentMethodDialog";
import CannotConvertDialog from "../../CannotConvertDialog";
import UpperCaseText from "../../../../utils/UpperCaseText";
import LowerCaseText from "../../../../utils/LowerCaseText";
import UiDateUtils from "../../../../utils/UiDateUtils";
import FinancialDetailsDialogBox from "./financialDetailsDialogBox/FinancialDetailsDialogBox";
import CustomerReservationsClient from "../../../../shared/clients/CustomerReservationsClient";
import {
  DISPLAY_PROPOSAL_FOR_MARKET,
  DISPLAY_PROPOSAL_FOR_MARKET_LEASE,
  NOTNULL_OR_NOTUNDEFINED,
  IS_FRANCE_MARKET,
} from "../../../../utils/EmpUtil";
import PaymentCalendarDialog from "./paymentCalendarDialog/PaymentCalendarDialog";
import FinanceOptions from "./financeOptions/FinanceOptions";
import FranceFinanceOptions from "./financeOptions/FranceFinanceOptions";
import LeaseOptions from "./leaseOptions/LeaseOptions";
import CashOptions from "./cashOptions/CashOptions";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../../../shared/ExpansionPanels/ExpansionPanel";
import { OrderDetailsNotification } from "../notifications/OrderDetailNotifications";
import SharedToolTip from "../../../../shared/sharedToolTip/SharedToolTip";

const StyledRadio = withStyles({
  root: {
    color: "#102b4e",
    "&$checked": {
      color: "#102b4e",
    },
  },
  checked: {},
})(Radio);

class PaymentMethod extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandPaymentMethod: true,
      openPaymentDialog: false,
      cannotConvertDialog: false,
      switchTo: "",
      openCalender: false,
      paymentType: "",
      showFinancialDetails: false,
      isApplyLaterPaymentType:
        this.props.customerReservation.paymentType === AL,
      paymentMethodToolTipOpen: false,
      switchPaymentInProcessError: false,
    };
    this.currentPaymentStatus = "";
    this.activeApplicationStatus = "";
    this.isApproved = false;
    this.canConvert = true;
    this.financialDetails = null;
    this.uwDecision = null;
    this.displayProposalNumber = DISPLAY_PROPOSAL_FOR_MARKET(
      this.props.selectedMarket
    );
    this.displayProposalNumberForLease = DISPLAY_PROPOSAL_FOR_MARKET_LEASE(
      this.props.selectedMarket
    );
    this.canEditPaymentMethod =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "paymentMethod:write"
      );
    this.displayPrivateLeasing =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "privateLeasePaymentType"
      );
  }

  handlePaymentChange = (event) => {
    if (
      this.currentPaymentStatus === LEASE ||
      this.currentPaymentStatus === FINANCE
    ) {
      const status = UpperCaseText(this.activeApplicationStatus);
      if (
        !(
          status === CANCELLED ||
          status === DENIED ||
          status === ERROR ||
          status === OPT_OFFLINE ||
          status === TIMED_OUT ||
          status === FINANCE_REFERRED ||
          status === FINANCE_EID_CHECKED_FAIL ||
          status === PROPOSAL_EXPIRED
        )
      ) {
        this.setState({
          cannotConvertDialog: true,
          switchPaymentInProcessError: true,
        });
        return;
      }
    }
    if (event.target.value === FINANCE) {
      if (this.canConvert) {
        this.setState({
          openPaymentDialog: true,
          switchTo: this.props.t("CustomerOrderDetails.finance"),
          paymentType: UpperCaseText(OFFLINE_FINANCE),
        });
      } else {
        this.setState({
          cannotConvertDialog: true,
          switchTo: this.props.t("CustomerOrderDetails.finance"),
          switchPaymentInProcessError: false,
        });
      }
    } else if (event.target.value === CASH) {
      if (this.canConvert) {
        this.setState({
          openPaymentDialog: true,
          switchTo: this.props.t("CustomerOrderDetails.cash"),
          paymentType: UpperCaseText(CASH),
        });
      } else {
        this.setState({
          cannotConvertDialog: true,
          switchTo: this.props.t("CustomerOrderDetails.cash"),
          switchPaymentInProcessError: false,
        });
      }
    } else if (event.target.value === PRIVATE_LEASE) {
      if (this.canConvert) {
        this.setState({
          openPaymentDialog: true,
          switchTo: this.props.t("CustomerOrderDetails.privateLease"),
          paymentType: LowerCaseText(OFFLINE_PRIVATE_LEASE),
        });
      } else {
        this.setState({
          cannotConvertDialog: true,
          switchTo: this.props.t("CustomerOrderDetails.privateLease"),
          switchPaymentInProcessError: false,
        });
      }
    } else {
      if (this.canConvert) {
        this.setState({
          openPaymentDialog: true,
          switchTo: this.props.t("CustomerOrderDetails.lease"),
          paymentType: UpperCaseText(OFFLINE_LEASE),
        });
      } else {
        this.setState({
          cannotConvertDialog: true,
          switchTo: this.props.t("CustomerOrderDetails.lease"),
          switchPaymentInProcessError: false,
        });
      }
    }
  };

  togglePaymentMethodToolTip = (event) => {
    event.stopPropagation();
    this.setState((prevState) => ({
      paymentMethodToolTipOpen: !prevState.paymentMethodToolTipOpen,
    }));
  };

  checkIsApproved = (paymentDesc) => {
    paymentDesc &&
      paymentDesc.length > 0 &&
      paymentDesc.forEach((item, index) => {
        if (UpperCaseText(item.status) === FINANCE_OPTIONS.APPROVED) {
          this.isApproved = true;
        }
        if (
          index === paymentDesc.length - 1 &&
          (UpperCaseText(item.status) === FINANCE_OPTIONS.FINANCE_REFERRED ||
            UpperCaseText(item.status) === FINANCE_OPTIONS.CANCELLED)
        ) {
          this.isApproved = false;
        }
      });
  };

  findStatus() {
    function setPaymentStatus(paymentType) {
      const paymentDesc = this.customerReservation.paymentDescription;
      this.currentPaymentStatus = paymentType;
      this.checkIsApproved(paymentDesc);
      this.canConvert = this.canConvertOrder();
      this.activeApplicationStatus =
        paymentDesc &&
        paymentDesc.length > 0 &&
        paymentDesc[paymentDesc.length - 1].status;
    }

    if (this.paymentType) {
      const paymentType = LowerCaseText(this.paymentType);
      if (paymentType === CASH) {
        setPaymentStatus.call(this, CASH);
      } else if (paymentType === FINANCE || paymentType === OFFLINEFINANCE) {
        setPaymentStatus.call(this, FINANCE);
      } else if (paymentType === LEASE || paymentType === OFFLINELEASE) {
        setPaymentStatus.call(this, LEASE);
      } else if (
        paymentType === PRIVATE_LEASE ||
        paymentType === OFFLINEPRIVATELEASE
      ) {
        setPaymentStatus.call(this, PRIVATE_LEASE);
      }
    }
  }

  expandPaymentMethod() {
    this.setState({ expandPaymentMethod: !this.state.expandPaymentMethod });
  }

  savePaymentChange = () => {
    this.closePaymentChangeDialog();
    const todayDate = this.customerReservation.todayDate;
    this.props.handleUpdatePaymentMethod(this.state.paymentType, todayDate);
    this.setState({ isApplyLaterPaymentType: false });
  };

  closePaymentChangeDialog = () => {
    this.setState({ openPaymentDialog: false, switchTo: "", paymentType: "" });
  };
  closeCannotConvertDialog = () => {
    this.setState({ cannotConvertDialog: false, switchTo: "" });
  };

  checkCashStatus = () => {
    const customerReservation = this.props.customerReservation;
    const hasCompletedFullPayment =
      customerReservation.finalPaymentConfirmedData &&
      customerReservation.finalPaymentConfirmedData.dealerAcceptedDate &&
      customerReservation.finalPaymentConfirmedData.dealerActionUserId;
    return !hasCompletedFullPayment;
  };
  checkFinanceStatus = () => {
    const hasCompletedFinanceContract =
      this.props.customerReservation &&
      this.props.customerReservation.contractSignedData &&
      this.props.customerReservation.contractSignedData.dealerAcceptedDate !==
        null;
    return !hasCompletedFinanceContract;
  };
  checkLeaseStatus = () => {
    const hasCompletedLeaseContract =
      this.props.customerReservation &&
      this.props.customerReservation.contractSignedData &&
      this.props.customerReservation.contractSignedData.dealerAcceptedDate !==
        null;
    return !hasCompletedLeaseContract;
  };

  saveCalendarChange = (date) => {
    const updatedStatus =
      this.currentPaymentStatus === PRIVATE_LEASE
        ? OFFLINE_PRIVATE_LEASE
        : this.currentPaymentStatus === FINANCE
        ? OFFLINE_FINANCE
        : OFFLINE_LEASE;
    this.props.handleUpdatePaymentMethod(updatedStatus, date);
    this.setState({ openCalender: false });
  };

  getTitleText = () => {
    const deposit =
      this.props.customerReservation &&
      this.props.customerReservation.pricingStack &&
      this.props.customerReservation.pricingStack.orderDepositPrice;
    return NOTNULL_OR_NOTUNDEFINED(deposit)
      ? this.props.t("PaymentMethod.preOrderDeposit") +
          " (" +
          this.props.defaultCurrency.concat(deposit) +
          ")"
      : this.props.t("PaymentMethod.preOrderDeposit");
  };

  changeApplicationStatus = () => {
    const openCalender = !this.state.openCalender;
    this.setState({ openCalender });
  };

  showFinancialDetailsPopup = () => {
    this.props.hideOrShow(true);
    CustomerReservationsClient.getCustomerFinanceDetails(
      this.props.user,
      this.props.customerReservation &&
        this.props.customerReservation.proposalNumber,
      this.props.selectedMarket
    )
      .then((result) => {
        this.financialDetails =
          result && result.content && result.content.length > 0
            ? result.content[0].proposalData
            : "--";
        this.uwDecision =
          result &&
          result.content &&
          result.content.length > 0 &&
          result.content[0].uwDecision;
      })
      .catch(() => {
        this.props.showErrorPopup(
          this.props.t("Error.processingErrorTitle"),
          this.props.t("Error.processingErrorMessage")
        );
      })
      .finally(() => {
        this.setState({ showFinancialDetails: true });
        this.props.hideOrShow(false);
      });
  };

  closeFinancialDetailsPopup = () => {
    this.setState({
      showFinancialDetails: false,
    });
  };

  proposalNumClickable = (paymentType) => {
    const markets = ["GBR", "FRA"];
    return (
      UpperCaseText(paymentType) === "FINANCE" &&
      markets.includes(this.props.selectedMarket)
    );
  };

  canConvertOrder = () => {
    if (this.props.handOverComplete) {
      return false;
    }
    switch (LowerCaseText(this.paymentType)) {
      case OFFLINEFINANCE:
        return this.checkFinanceStatus();
      case FINANCE:
        return !this.isApproved;
      case OFFLINELEASE:
        return this.checkLeaseStatus();
      case LEASE:
        return !this.isApproved;
      case CASH:
        return this.checkCashStatus();
      case OFFLINEPRIVATELEASE:
        return this.checkFinanceStatus();
      case PRIVATE_LEASE:
        return !this.isApproved;
      default:
        return false;
    }
  };

  paymentOptions = (
    id,
    checked,
    text,
    customerReservation,
    paymentReceived,
    name
  ) => {
    const date = customerReservation.orderConfirmedDate;
    return (
      <div className={styles.paymentDetails} data-testid={`${id}_details`}>
        <CheckBox
          id={id}
          checked={checked}
          isDisabled={true}
          label={text}
          textClass={checkboxStyles.boldLabel}
        />
        <div className={styles.info}>
          <span className={styles.paymentInfo}>
            {UiDateUtils.formattedDate(date)}
          </span>
          <span className={styles.greenText}>
            {CapitalizeText(paymentReceived)}
          </span>
          <span className={styles.name}>{name}</span>
        </div>
      </div>
    );
  };

  getCssStyle = (status) => {
    switch (UpperCaseText(status)) {
      case FINANCE_OPTIONS.APPROVED:
      case "COMPLETED":
        return styles.statusGreen;
      case "ERROR":
      case "FINANCE_EID_CHECKED_FAIL":
      case "FINANCE_REFERRED":
      case "CANCELLED":
      case "DECLINED":
        return styles.statusOrange;
      case "INPROGRESS":
        return styles.statusNormal;
      default:
        return styles.defaultStatus;
    }
  };
  showPaymentStep = (status) => {
    switch (UpperCaseText(status)) {
      case FINANCE_OPTIONS.WETSIGN_OFFLINE:
        return false;
      default:
        return true;
    }
  };

  financeOrLeaseApplication = () => {
    const props = this.props;
    const orderDetails = this.customerReservation;
    return (
      // eslint-disable-next-line
      <>
        {orderDetails.paymentDescription &&
          orderDetails.paymentDescription.map((payment) => {
            return (
              this.showPaymentStep(payment.status) && (
                <div className={styles.info}>
                  <span className={styles.paymentInfo}>
                    {UiDateUtils.formattedDate(payment.date)}
                  </span>

                  {UpperCaseText(payment.status) === FINANCE_OPTIONS.APPROVED &&
                  (LowerCaseText(this.paymentType) === OFFLINEFINANCE ||
                    LowerCaseText(this.paymentType) === OFFLINELEASE ||
                    LowerCaseText(this.paymentType) === OFFLINEPRIVATELEASE) ? (
                    <>
                      <span className={styles.offlineApproved}>
                        {CapitalizeText(props.t("PaymentMethod.offline"))}
                      </span>
                      <span className={this.getCssStyle(payment.status)}>
                        {CapitalizeText(payment.statusDesc)}
                      </span>
                      <span className={styles.name}>
                        {CapitalizeText(this.financeDataDealerUserId)}
                      </span>
                    </>
                  ) : (
                    <span className={this.getCssStyle(payment.status)}>
                      {CapitalizeText(payment.statusDesc)}
                    </span>
                  )}
                  {!!orderDetails.proposalNumber &&
                    this.showProposal(payment.status, this.paymentType) && (
                      <span
                        className={
                          this.proposalNumClickable(this.paymentType)
                            ? styles.proposalNumLink
                            : styles.proposalNum
                        }
                        onClick={
                          this.proposalNumClickable(this.paymentType) &&
                          this.showFinancialDetailsPopup
                        }
                      >
                        {props
                          .t("PaymentMethod.proposalNum")
                          .concat(orderDetails.proposalNumber)}
                      </span>
                    )}
                  {this.financeDataDealerUserId &&
                    (LowerCaseText(this.paymentType) === OFFLINEFINANCE ||
                      LowerCaseText(this.paymentType) === OFFLINELEASE ||
                      LowerCaseText(this.paymentType) ===
                        OFFLINEPRIVATELEASE) && (
                      <span className={styles.name}>
                        ({this.financeDataDealerUserId})
                      </span>
                    )}
                </div>
              )
            );
          })}
      </>
    );
  };

  showProposal = (status, paymentType) => {
    switch (UpperCaseText(paymentType)) {
      case UpperCaseText(FINANCE):
        return (
          this.displayProposalNumber && UpperCaseText(status) === SUBMITTED
        );
      case UpperCaseText(LEASE):
        return (
          this.displayProposalNumberForLease &&
          UpperCaseText(status) === SUBMITTED
        );
      default:
        return false;
    }
  };

  getFinanceDisplayStatus = () => {
    const props = this.props;
    let displayStatus = "";
    const payment = this.customerReservation.paymentDescription;
    if (
      (payment &&
        payment.length > 0 &&
        payment[payment.length - 1].status === FINANCE_OPTIONS.APPROVED) ||
      "INPROGRESS"
    ) {
      displayStatus = props.t("PaymentMethod.paymentReceived");
    }
    return displayStatus;
  };

  render() {
    this.customerReservation = this.props.customerReservation;
    this.status = this.customerReservation && this.customerReservation.status;
    this.paymentType =
      this.customerReservation && this.customerReservation.paymentType;
    this.financeDataDealerUserId =
      this.customerReservation &&
      this.customerReservation.financeDataDealerUserId;

    this.findStatus();

    return (
      <div>
        <StyledBasicExpansionPanel
          defaultExpanded={true}
          onChange={() => this.expandPaymentMethod()}
        >
          <StyledBasicExpansionPanelSummary style={crStyles.headerBarNeutral}>
            <div className={sharedStyles.headerBar}>
              <div className={sharedStyles.boldHeaderWithToolTip}>
                {this.props.t("PaymentMethod.paymentMethod")}
                <SharedToolTip
                  openTestid="paymentMethodToolTipOpen"
                  open={this.state.paymentMethodToolTipOpen}
                  closeTooltip={this.togglePaymentMethodToolTip}
                  openTooltip={this.togglePaymentMethodToolTip}
                  body={this.props.t("PaymentMethod.toolTip")}
                />
              </div>
              {this.state.expandPaymentMethod ? (
                <ExpandLessIcon id="less" />
              ) : (
                <ExpandMoreIcon id="more" />
              )}
            </div>
            <br />
          </StyledBasicExpansionPanelSummary>
          <div className={styles.paymentInfoGrid}>
            <div className={styles.bottomBorder}></div>
            {this.state.isApplyLaterPaymentType && (
              <OrderDetailsNotification
                user={this.props.user}
                showActionRequired={this.props.t(
                  "CustomerOrderDetails.actionRequired"
                )}
                showMessage={this.props.t(
                  "PaymentMethod.arrangeFinanceOfflineMessage"
                )}
                showPriority={this.props.t(
                  "CustomerOrderDetails.mediumPriority"
                )}
                warningColor={true}
              />
            )}
            <div className={styles.paymentBox}>
              {this.props.isOrderCancelled(this.status) && (
                <div className={this.props.overlay} />
              )}
              <FormControl
                component="fieldset"
                className={styles.radioContainer}
              >
                <RadioGroup
                  name="paymentMethod"
                  value={
                    this.state.isApplyLaterPaymentType
                      ? null
                      : this.currentPaymentStatus
                  }
                  onChange={this.handlePaymentChange}
                >
                  <FormControlLabel
                    value="lease"
                    control={<StyledRadio />}
                    className={styles.labels}
                    disabled={!this.canEditPaymentMethod}
                    data-testid="leasePayment"
                    label={this.props.t("PaymentMethod.lease")}
                  />
                  {!this.state.isApplyLaterPaymentType &&
                    this.currentPaymentStatus === LEASE && (
                      <>
                        {this.paymentOptions(
                          "lease_deposit",
                          true,
                          this.getTitleText(),
                          this.customerReservation,
                          this.getFinanceDisplayStatus(),
                          ""
                        )}
                        <div
                          className={styles.paymentDetails}
                          data-testid="lease_application"
                        >
                          {this.isApproved ? (
                            <div data-testid="lease_payment">
                              <CheckBox
                                id="lease_payment_id"
                                checked={true}
                                isDisabled={true}
                                label={this.props.t(
                                  "PaymentMethod.leaseApplication"
                                )}
                                onChange={(e) =>
                                  this.changeApplicationStatus(e)
                                }
                                textClass={checkboxStyles.boldLabel}
                              />
                              {this.financeOrLeaseApplication()}
                              <LeaseOptions
                                {...this.props}
                                activeApplicationStatus={
                                  this.activeApplicationStatus
                                }
                                paymentType={this.paymentType}
                                customerReservation={this.customerReservation}
                              />
                            </div>
                          ) : (
                            this.customerReservation.paymentDescription && (
                              <>
                                <PaymentCalendarDialog
                                  {...this.props}
                                  confirmDialog={this.saveCalendarChange}
                                  label={this.props.t(
                                    "PaymentMethod.leaseApplication"
                                  )}
                                  todayDate={this.customerReservation.todayDate}
                                  paymentType={this.paymentType}
                                  activeApplicationStatus={
                                    this.activeApplicationStatus
                                  }
                                  canConvert={
                                    this.canConvert && this.canEditPaymentMethod
                                  }
                                />
                                {this.financeOrLeaseApplication()}
                              </>
                            )
                          )}
                        </div>
                      </>
                    )}

                  <FormControlLabel
                    value="cash"
                    control={<StyledRadio />}
                    className={styles.labels}
                    disabled={!this.canEditPaymentMethod}
                    data-testid="cashPayment"
                    label={this.props.t("PaymentMethod.cash")}
                  />
                  {!this.state.isApplyLaterPaymentType &&
                    this.currentPaymentStatus === CASH && (
                      <>
                        {this.paymentOptions(
                          "cash_deposit",
                          true,
                          this.getTitleText(),
                          this.customerReservation,
                          this.getFinanceDisplayStatus()
                        )}
                        <div
                          className={styles.paymentDetails}
                          data-testid="finance_application"
                        >
                          <div>
                            <CashOptions
                              {...this.props}
                              activeApplicationStatus={
                                this.activeApplicationStatus
                              }
                              paymentType={this.paymentType}
                              customerReservation={this.customerReservation}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  <FormControlLabel
                    value="finance"
                    control={<StyledRadio />}
                    className={styles.labels}
                    disabled={!this.canEditPaymentMethod}
                    data-testid="financePayment"
                    label={this.props.t("PaymentMethod.finance")}
                  />
                  {!this.state.isApplyLaterPaymentType &&
                    this.currentPaymentStatus === FINANCE && (
                      <>
                        {this.paymentOptions(
                          "finance_deposit",
                          true,
                          this.getTitleText(),
                          this.customerReservation,
                          this.getFinanceDisplayStatus(),
                          ""
                        )}
                        <div
                          className={styles.paymentDetails}
                          data-testid="finance_application"
                        >
                          <div>
                            <div data-testid="finance_payment">
                              <CheckBox
                                id="finance_payment_id"
                                checked={this.isApproved}
                                isDisabled={
                                  !(
                                    this.canConvert && this.canEditPaymentMethod
                                  ) || this.isApproved
                                }
                                label={this.props.t(
                                  "PaymentMethod.financeApplication"
                                )}
                                onChange={() => {
                                  this.props.handleUpdatePaymentMethod(
                                    OFFLINE_FINANCE,
                                    this.props.customerReservation.todayDate
                                  );
                                  this.checkIsApproved(
                                    this.customerReservation.paymentDescription
                                  );
                                }}
                                textClass={checkboxStyles.boldLabel}
                              />
                              {this.financeOrLeaseApplication()}
                            </div>
                            <div>
                              {IS_FRANCE_MARKET(this.props.selectedMarket) ? (
                                <FranceFinanceOptions
                                  {...this.props}
                                  activeApplicationStatus={
                                    this.activeApplicationStatus
                                  }
                                  paymentType={this.paymentType}
                                  customerReservation={this.customerReservation}
                                />
                              ) : (
                                <FinanceOptions
                                  {...this.props}
                                  activeApplicationStatus={
                                    this.activeApplicationStatus
                                  }
                                  paymentType={this.paymentType}
                                  customerReservation={this.customerReservation}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                  {this.displayPrivateLeasing && (
                    <FormControlLabel
                      value="private lease"
                      control={
                        <StyledRadio
                          checked={this.currentPaymentStatus === PRIVATE_LEASE}
                        />
                      }
                      className={styles.labels}
                      disabled={!this.canEditPaymentMethod}
                      data-testid="privateLeasePayment"
                      label={this.props.t("PaymentMethod.privateLease")}
                    />
                  )}
                  {!this.state.isApplyLaterPaymentType &&
                    this.currentPaymentStatus === PRIVATE_LEASE && (
                      <>
                        {this.paymentOptions(
                          "finance_deposit",
                          true,
                          this.getTitleText(),
                          this.customerReservation,
                          this.getFinanceDisplayStatus(),
                          ""
                        )}
                        <div
                          className={styles.paymentDetails}
                          data-testid="finance_application"
                        >
                          <div>
                            <div data-testid="finance_payment">
                              <CheckBox
                                id="finance_payment_id"
                                checked={this.isApproved}
                                isDisabled={
                                  !(
                                    this.canConvert && this.canEditPaymentMethod
                                  ) || this.isApproved
                                }
                                label={this.props.t(
                                  "PaymentMethod.privateLeaseApplication"
                                )}
                                onChange={() => {
                                  this.props.handleUpdatePaymentMethod(
                                    OFFLINE_PRIVATE_LEASE,
                                    this.props.customerReservation.todayDate
                                  );
                                  this.checkIsApproved(
                                    this.customerReservation.paymentDescription
                                  );
                                }}
                                textClass={checkboxStyles.boldLabel}
                              />
                              {this.financeOrLeaseApplication()}
                            </div>
                            <div>
                              {/*private lease */}
                              <FinanceOptions
                                {...this.props}
                                activeApplicationStatus={
                                  this.activeApplicationStatus
                                }
                                paymentType={this.paymentType}
                                customerReservation={this.customerReservation}
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        </StyledBasicExpansionPanel>

        <PaymentMethodDialog
          {...this.props}
          open={this.state.openPaymentDialog}
          paymentType={this.state.switchTo}
          closeDialog={this.closePaymentChangeDialog}
          confirmDialog={this.savePaymentChange}
        />
        {this.state.showFinancialDetails && (
          <FinancialDetailsDialogBox
            {...this.props}
            boxOpen={this.state.showFinancialDetails}
            name="dialogBxConfirm"
            id="dialogBxConfirm"
            closePopup={this.closeFinancialDetailsPopup}
            financialDetails={this.financialDetails}
            uwDecision={this.uwDecision}
            proposalNumber={
              this.props.customerReservation &&
              this.props.customerReservation.proposalNumber
            }
          />
        )}
        <CannotConvertDialog
          open={this.state.cannotConvertDialog}
          paymentType={this.state.switchTo}
          activeStatus={this.activeApplicationStatus}
          switchPaymentInProcessError={this.state.switchPaymentInProcessError}
          closeDialog={this.closeCannotConvertDialog}
        />
      </div>
    );
  }
}

export default withTranslation("emp")(PaymentMethod);
